module.exports = __webpack_public_path__ + "static/EWY_Shar_social-15dd2a1b5b4060e7ed9e2942046fd15d.mp4";